const LOGO_SR_ONLY_KEY = "Nx:Portail MRE par Attijariwafa Bank"

const sharedWebformFallbacks = {
	"Numéro de téléphone": {
		fr: "Numéro de téléphone",
		en: "Phone number",
		ar: "رقم الهاتف",
		Tfng: "Numéro de téléphone",
		it: "Numero di telefono",
		es: "Número de teléfono",
		nl: "Telefoonnummer",
		de: "Telefonnummer",
	},
	"Nx: est requis.": {
		fr: "est requis.",
		en: "is required.",
		ar: "مطلوب.",
		Tfng: "est requis.",
		it: "è obbligatorio.",
		es: "es obligatorio.",
		nl: "is verplicht.",
		de: "ist erforderlich.",
	},
	"Nx: Le champ": {
		fr: "Le champ",
		en: "The field",
		ar: "الحقل",
		Tfng: "Le champ",
		it: "Il campo",
		es: "El campo",
		nl: "Het veld",
		de: "Das Feld",
	},
	"Nx: est invalid.": {
		fr: "est invalid.",
		en: "is invalid.",
		ar: "غير صالح.",
		Tfng: "est invalid.",
		it: "non è valido.",
		es: "no es válido.",
		nl: "is ongeldig.",
		de: "ist ungültig.",
	},
	"Nx:Le champ Téléphone est requis.": {
		fr: "Le champ Téléphone est requis.",
		en: "The Phone field is required.",
		ar: "حقل الهاتف مطلوب.",
		Tfng: "Le champ Téléphone est requis.",
		it: "Il campo Telefono è obbligatorio.",
		es: "El campo Teléfono es obligatorio.",
		nl: "Het veld Telefoon is verplicht.",
		de: "Das Feld Telefon ist erforderlich.",
	},
	"Nx:Le champ E-mail n'est pas valide": {
		fr: "Le champ E-mail n'est pas valide",
		en: "The Email field is not valid",
		ar: "حقل البريد الإلكتروني غير صالح",
		Tfng: "Le champ E-mail n'est pas valide",
		it: "Il campo E-mail non è valido",
		es: "El campo E-mail no es válido",
		nl: "Het veld E-mail is niet geldig",
		de: "Das Feld E-Mail ist ungültig",
	},
	"Nx:Je souhaite recevoir les sollicitations commerciales de Attijariwafa bank et ses filiales par :":
		{
			fr: "Je souhaite recevoir les sollicitations commerciales de Attijariwafa bank et ses filiales par :",
			en: "I would like to receive commercial solicitations from Attijariwafa bank and its subsidiaries by:",
			ar: "أرغب في تلقي العروض التجارية من Attijariwafa bank وشركاتها التابعة عبر:",
			Tfng: "Je souhaite recevoir les sollicitations commerciales de Attijariwafa bank et ses filiales par :",
			it: "Desidero ricevere sollecitazioni commerciali da Attijariwafa bank e dalle sue filiali tramite:",
			es: "Deseo recibir solicitudes comerciales de Attijariwafa bank y sus filiales por:",
			nl: "Ik wil commerciële aanbiedingen van Attijariwafa bank en zijn dochterondernemingen ontvangen via:",
			de: "Ich möchte werbliche Angebote von Attijariwafa bank und seinen Tochtergesellschaften erhalten über:",
		},
	"Nx:": {
		fr: "",
		en: "",
		ar: "",
		Tfng: "",
		it: "",
		es: "",
		nl: "",
		de: "",
	},
	"Nx:utm_medium": {
		fr: "",
		en: "",
		ar: "",
		Tfng: "",
		it: "",
		es: "",
		nl: "",
		de: "",
	},
	"Nx:utm_source": {
		fr: "",
		en: "",
		ar: "",
		Tfng: "",
		it: "",
		es: "",
		nl: "",
		de: "",
	},
	"Nx:utm_campaign": {
		fr: "",
		en: "",
		ar: "",
		Tfng: "",
		it: "",
		es: "",
		nl: "",
		de: "",
	},
	"Nx:user_id": {
		fr: "",
		en: "",
		ar: "",
		Tfng: "",
		it: "",
		es: "",
		nl: "",
		de: "",
	},
}

const localeSpecificFallbacks = {
	fr: {
		[LOGO_SR_ONLY_KEY]: "Portail MRE par Attijariwafa Bank",
	},
	en: {
		[LOGO_SR_ONLY_KEY]: "MRE Portal by Attijariwafa Bank",
	},
	ar: {
		[LOGO_SR_ONLY_KEY]: "بوابة المغاربة المقيمين بالخارج من Attijariwafa bank",
	},
	Tfng: {
		[LOGO_SR_ONLY_KEY]: "Portail MRE par Attijariwafa Bank",
	},
	it: {
		[LOGO_SR_ONLY_KEY]: "Portale MRE di Attijariwafa Bank",
	},
	es: {
		[LOGO_SR_ONLY_KEY]: "Portal MRE de Attijariwafa Bank",
	},
	nl: {
		[LOGO_SR_ONLY_KEY]: "MRE-portal van Attijariwafa Bank",
	},
	de: {
		[LOGO_SR_ONLY_KEY]: "MRE-Portal von Attijariwafa Bank",
	},
}

const buildLocaleFallbacks = (locale) => {
	const entries = Object.entries(sharedWebformFallbacks).map(([key, translations]) => [
		key,
		translations[locale] ?? translations.fr,
	])

	return {
		...Object.fromEntries(entries),
		...(localeSpecificFallbacks[locale] || localeSpecificFallbacks.fr),
	}
}

const fallbackTranslationsByLocale = Object.fromEntries(
	["fr", "en", "ar", "Tfng", "it", "es", "nl", "de"].map((locale) => [
		locale,
		buildLocaleFallbacks(locale),
	])
)

export const getFallbackTranslations = (locale) =>
	fallbackTranslationsByLocale[locale] || fallbackTranslationsByLocale.fr
